export default __webpack_public_path__ + "assets/profeature-card-small.5f4a4d00935bf56d15917982325bb516.jpg";